<script>
	import { postReq } from '../../../../services/http';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';

	import { format } from '../../../../services/i18n';
	import { real_id } from '../../../../helpers/interface_helpers';
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';
	export let device;

	const id = real_id(device.id);
	let types = [50, 120];
	const settings = readDeviceSettings(id);
	let selected = settings[device.category + 's'][device.channel].ctraf_type;
	let cache = selected;
	let loading = false;
	console.warn(settings);
	const setDefault = async (state) => {
		selected = state;
	};
	const sentRequest = async () => {
		if (cache !== selected) {
			loading = true;
			const res = await postReq(`device/${device.category}/settings/transformer_type`, {
				channel: device.channel,
				ctraf_type: selected,
				id,
			});
			if (res.isok) {
				settings[device.category + 's'][device.channel].ctraf_type = selected;
				toast.open({
					type: 'success',
					title:
						$format('transformer_type_scc_toast', {
							values: { value: selected },
						}) || `Power on was changed to ${selected}`,
				});
				devices_settings.update_devices_settings(id, settings);
				cache = selected;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				selected = cache;
				throw new Error('damn error');
			}
			loading = false;
		}
	};
</script>

<Radio size="m" {selected} value={types[0]} on:click={() => setDefault(50)} id="radio-nnx3giw">50A</Radio
>
<Radio size="m" {selected} value={types[1]} on:click={() => setDefault(120)} id="radio-15n2cay"
	>120A</Radio
>
<Button {loading} class="mt-s" size="m" width="full" on:click={sentRequest}
	>{$format('button_save')}</Button
>
